/**
 * Stored enum values as a person reads them.
 *
 * Tables printed the raw value ("PREMIUM_HIRING_REQUEST", "MANAGED") beside values that happened
 * to be stored in title case ("Scale", "Growth"), so one column mixed shouting and not. Chips,
 * cells and filter options are sentence case: first word capitalised, the rest as written in a
 * sentence, which is also what SearchFilter's option chips and CRMStatusChip's fallback already do.
 *
 * Display only. Filter on the stored value, never on this.
 */

/**
 * Values whose words are not the right words. "Premium Hiring" is the product's name on screen
 * (copy change 50919b1), so it keeps its capitals inside a sentence-cased label.
 */
const KNOWN_LABELS: Record<string, string> = {
  PREMIUM_HIRING_REQUEST: 'Premium Hiring request',
  HR_ON_BEHALF: 'Added by HR',
  // The stored tier / hiring mode stays MANAGED; the service is called Premium Hiring on screen
  // (owner decision 2026-10-07).
  MANAGED: 'Premium Hiring',
  // A redeemed city-expansion promo code: one free job post, a ₹0 subscription row.
  PROMO_CITY: 'Free city post',
};

/** Acronyms that stay upper case inside a sentence-cased label. */
const ACRONYMS = new Set(['hr', 'ai', 'cv', 'id', 'url', 'utm', 'upi', 'usd', 'inr', 'api', 'csv', 'seo', 'cta', 'sms']);

export const humanizeEnum = (value: string | null | undefined, empty = '-'): string => {
  if (value === null || value === undefined) return empty;
  const raw = String(value).trim();
  if (!raw) return empty;
  const known = KNOWN_LABELS[raw.toUpperCase()];
  if (known) return known;
  const words = raw
    .replace(/([a-z])([A-Z])/g, '$1 $2')
    .replace(/[_-]+/g, ' ')
    .trim()
    .split(/\s+/)
    .map((w) => w.toLowerCase())
    .map((w) => (ACRONYMS.has(w) ? w.toUpperCase() : w));
  const sentence = words.join(' ');
  return sentence.charAt(0).toUpperCase() + sentence.slice(1);
};
